<template>
  <header class="header">
    <div class="header__menu">
      <p class="header__welcome" v-if="user">Bienvenido {{user.first_name}} {{user.last_name}}</p>
      <div class="options">
        <button class="options__btn" @click.stop="showOptions = !showOptions"></button>
        <div class="options__list" v-if="showOptions">
          <button class="options__option options__option--account">Mi datos</button>
          <button class="options__option options__option--logout" @click.prevent="logout">Cerrar sesión</button>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import {auth} from '@/core/libs/sessions'
export default {
  data: function () {
    return {
      showOptions: false
    }
  },
  mounted: function () {
    document.addEventListener('click', () => {
      this.showOptions = false
    })
  },
  methods: {
    logout: function () {
      auth.logout()
        .then(
          () => {
            this.$store.commit('logout')
            this.$router.push({name: 'signIn'})
          }
        )
    }
  },
  computed: {
    user: function () {
      if (this.$store.state.user) {
        return this.$store.state.user
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../assets/sass/components/_header"
</style>



// WEBPACK FOOTER //
// src/components/header.vue